import { UTLoading } from '@group-link-one/gl-ui/utilities';
import type { JSX } from 'react';
import { AuthRoutes } from './auth.routes';
import { AuthenticatedRoutes } from './authenticated.routes';
import { useAuth } from '@/Auth';

export const Routes = (): JSX.Element => {
  const { isAuthenticated: authenticated, isLoading } = useAuth();

  // Show loading while checking authentication
  if (isLoading) {
    return <UTLoading screen='as-full-screen' type='dots' />;
  }

  // Only render one set of routes based on authentication
  if (!authenticated) {
    return <AuthRoutes />;
  }

  return <AuthenticatedRoutes />;
};
